// removed by extract-text-webpack-plugin
module.exports = {"DepositTipsContent":"DepositTipsContent"};


//////////////////
// WEBPACK FOOTER
// ./src/components/areas/Account/DepositQr/styles.scss
// module id = 2293
// module chunks = 10